var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRepublic = function SvgRepublic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#157EFE",
    fillRule: "evenodd",
    d: "m12.402 12.372 5.94 8.025H.81V.747h9.22c.32 0 .623.016.892.033 3.062.235 5.484 2.81 5.484 5.955a6.02 6.02 0 0 1-4.004 5.636",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#157EFE",
    fillRule: "evenodd",
    d: "M12.217 20.397H.81V.747l17.413 19.65z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00BDFF",
    fillRule: "evenodd",
    d: "M18.341 20.396H.811L9.507 6.668z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1560FA",
    fillRule: "evenodd",
    d: "M.81 12.12V.745h4.896l7.302 11.373z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00EFE9",
    fillRule: "evenodd",
    d: "m6.06 12.119 3.448-5.451 3.5 5.45z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#009BFF",
    fillRule: "evenodd",
    d: "M18.341 20.396h-6.51L9.524 6.668z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1AFBA",
    fillRule: "evenodd",
    d: "M27.14 7.274v2.288h1.38c1.06 0 1.564-.539 1.564-1.161.017-.656-.521-1.127-1.565-1.127zm1.43-1.733c2.052 0 3.398 1.194 3.398 2.86 0 1.598-.925 2.557-1.968 2.759l2.17 3.752h-2.153l-1.985-3.517h-.875v3.517h-1.935V5.54zm6.393 5.518h2.978c-.168-.824-.69-1.295-1.464-1.295-.858 0-1.363.488-1.514 1.295m4.795.606c0 .202-.017.437-.034.589h-4.761c.202.942.875 1.346 1.733 1.346.589 0 1.211-.236 1.7-.623l1.059 1.127c-.757.673-1.733.976-2.86.976-2.07 0-3.5-1.346-3.5-3.399 0-2.035 1.397-3.432 3.399-3.432 1.935.017 3.247 1.397 3.264 3.416m3.297 0c0 1.026.707 1.783 1.733 1.783 1.077 0 1.733-.79 1.733-1.783s-.673-1.784-1.733-1.784c-1.043 0-1.733.774-1.733 1.784m5.317 0c0 1.951-1.397 3.415-3.247 3.415-.909 0-1.548-.337-1.986-.841v3.348h-1.8v-9.17h1.767v.724c.437-.521 1.076-.892 2.002-.892 1.867 0 3.264 1.481 3.264 3.416m7.739.488c0 2.052-1.498 2.927-3.18 2.927s-3.18-.892-3.18-2.927V8.435h1.8V12c0 1.043.59 1.464 1.38 1.464.774 0 1.38-.42 1.38-1.464V8.435h1.8zm3.516-.488c0 1.026.706 1.783 1.733 1.783 1.077 0 1.733-.79 1.733-1.783S62.42 9.88 61.36 9.88c-1.043 0-1.733.774-1.733 1.784m5.316 0c0 1.951-1.396 3.415-3.247 3.415-.925 0-1.581-.353-2.019-.892v.724h-1.766v-9.64h1.8v3.835c.438-.504 1.077-.858 1.968-.858 1.868 0 3.264 1.481 3.264 3.416m1.48 3.264h1.818v-9.64h-1.817zm3.702-.017h1.817V8.418h-1.817zm2.053-8.597c0 .622-.505 1.11-1.161 1.11s-1.144-.488-1.144-1.11.504-1.128 1.144-1.128c.656 0 1.16.488 1.16 1.128m7.52 3.163-1.312 1.043c-.404-.42-.841-.656-1.43-.656-.943 0-1.683.706-1.683 1.783 0 1.094.74 1.783 1.683 1.783.588 0 1.076-.252 1.463-.656l1.296 1.06c-.64.79-1.582 1.211-2.692 1.211-2.137 0-3.584-1.446-3.584-3.415 0-1.968 1.43-3.415 3.584-3.415 1.11.033 2.052.488 2.675 1.262",
    clipRule: "evenodd"
  })));
};
export { SvgRepublic as ReactComponent };